import { token } from '@atlaskit/tokens';

export const SECTION_EXTENSION_KEY = 'hub-section';
export const SECTION_EXTENSION_ANALYTICS_SOURCE = 'hub-sectionExtensionConfig';

export enum CONTENT_WIDTH {
	NARROW = 'narrow',
	WIDE = 'wide',
	FULL = 'full',
}
export const DEFAULT_CONTENT_WIDTH = CONTENT_WIDTH.WIDE;
export const DEFAULT_BACKGROUND_COLOR = token('elevation.surface.overlay');
